// noinspection DuplicatedCode

import { I18N_CONFIG } from '@constants'
import i18next from 'i18next'
import ChainedBackend from 'i18next-chained-backend'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import settings from './settings'

// noinspection SpellCheckingInspection
const options = {
  debug: false,
  lng: I18N_CONFIG.DEFAULT_LANGUAGE,
  fallbackLng: I18N_CONFIG.FALLBACK_LANGUAGE,
  supportedLngs: ['en-US', ...settings.languages],
  ns: I18N_CONFIG.NAMESPACE,
  defaultNS: I18N_CONFIG.NAMESPACE,
  react: {
    useSuspense: true
  },
  backend: {
    backends: [HttpBackend],
    backendOptions: [{ loadPath: '/i18n/{{lng}}.json' }]
  }
}

void i18next.use(ChainedBackend).use(initReactI18next).init(options)
